export default {
  defaultLang: 'en_US',
  languages: {
    'zh_TW': '繁體中文',
    'en_US': 'English(US)',
  },
}


//////////////////
// WEBPACK FOOTER
// ./static/config.js
// module id = /98u
// module chunks = 1